import React, { memo, useCallback, useState } from 'react';
import classNames from 'classnames';
import { Bubble, BubbleProps } from 'tea-component';
import './index.scss';

interface ICardIconButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  bubbleProps?: BubbleProps;
}

const CardIconButton: React.FC<ICardIconButtonProps> = (props) => {
  const {
    children,
    className,
    active = false,
    disabled = false,
    bubbleProps,
    onClick,
    ...rest
  } = props;
  const handleClick: React.MouseEventHandler<HTMLDivElement> = (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    onClick?.(event);
  };
  const [containerNode, setContainerNode] = useState<HTMLDivElement | null>(null);
  const buttonNode = (
    <div
      ref={setContainerNode}
      className={classNames('dbl-card-icon-button', className, {
        'dbl-card-icon-button--active': active,
        'dbl-card-icon-button--disabled': disabled,
      })}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </div>
  );

  if (!bubbleProps) {
    // 兼容场景：部分图标按钮不需要气泡提示（bubbleProps 为空）。
    // 这时直接返回 buttonNode，避免无意义包裹 Bubble 导致样式/事件行为变化。
    return buttonNode;
  }

  // popupContainer 和 positionFixed的设置是为了全屏模式下，dropdown 的定位正确
  // 注意由于这里设置了positionFixed为false, 所以父级当中如果出现了overflow: hidden, 可能会导致浮窗看不到.
  return (
    <Bubble
      placement="top"
      arrowPointAtCenter
      dark
      popupContainer={containerNode || undefined}
      positionFixed={false}
      overlayStyle={{
        width: 'max-content',
      }}
      {...bubbleProps}
    >
      {buttonNode}
    </Bubble>
  );
};

export default memo(CardIconButton);
